import type {ProductType} from 'nutshell-graphql-types';
import type {QuoteTerm as ProductTerm} from 'nutshell-graphql-types';

export const DEFAULT_PRODUCT_TYPE: ProductType = 'GOOD';

export const PRODUCT_TYPE_SELECT_OPTIONS: {
    value: ProductType;
    label: string;
}[] = [
    {value: 'GOOD', label: 'Good'},
    {value: 'SERVICE', label: 'Service'},
];

export const UNIT_SELECT_OPTIONS: {
    value: ProductTerm;
    label: string;
}[] = [
    {value: 'MINUTE', label: 'Minute'},
    {value: 'HOUR', label: 'Hour'},
    {value: 'DAY', label: 'Day'},
    {value: 'WEEK', label: 'Week'},
    {value: 'MONTH', label: 'Month'},
    {value: 'QUARTER', label: 'Quarter'},
    {value: 'YEAR', label: 'Year'},
];
